import { ProxyUI } from '@wpsocio/shared-ui/wptelegram/proxy/proxy';
import { PREFIX } from './constants';

export const ProxyTab: React.FC = () => {
	return <ProxyUI prefix={PREFIX} />;
};
